const ImageRecognition = () => {
  return (
    <div> hello ImageRecognition    </div>
  )
}

export default ImageRecognition